import { Injectable } from '@angular/core';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  private userIdSet = false;

  constructor() {}

  public setCurrentUser(userId: string) {
    // Only set user_id if it's a valid, non-empty string
    // This prevents GA4 warnings about invalid user IDs
    if (userId && userId.trim() !== '' && userId !== 'null' && userId !== 'undefined') {
      gtag('set', {'user_id': userId});
      gtag('set', 'user_properties', {
        app_user_id: userId
      });
      this.userIdSet = true;
    } else {
      console.warn('Analytics: Attempted to set invalid user_id:', userId);
    }
  };

  public isUserIdSet(): boolean {
    return this.userIdSet;
  }

  public setEbmsFlag () {
    gtag('event', 'ebmsUser', {
      'event_category': 'ebmsUser',
      'event_label': 'ebmsUser',
    });
  }

  public setEbmsDriverFlow (){
    gtag('event', 'ebmsDriverFlow', {
      'event_category': 'ebmsDriverFlow',
      'event_label': 'ebmsDriverFlow',
    });
  }

  public trackSubmission(submissionType: string) {
     gtag('event', submissionType, {
      'event_category': submissionType,
      'event_label': submissionType,
    });
  }
  
   public trackEbmsWBNudgeShown() {
    gtag('event', 'ebms_wb_nudge_shown', {
      'event_category': 'ebms_wb_nudge_shown',
      'event_label': 'ebms_wb_nudge_shown'
    });
   }

    public trackSaveAndExitButton(option: string) {
     gtag('event', `save_exit_${option}`, {
      'event_category': `save_exit_${option}`,
      'event_label': `save_exit_${option}`,
    });
  }

  public trackLinkExpiredScreen(option: string) {
     gtag('event', `ebms_${option}`, {
      'event_category': `ebms_${option}`,
      'event_label': `ebms_${option}`,
    });
  }

   public trackEbmsWrngPopup() {
    gtag('event', 'ebms_saveExit_modal_shown', {
      'event_category': 'ebms_saveExit_modal_shown',
      'event_label': 'ebms_saveExit_modal_shown'
    });
   }

  public trackEndCoverageEvent(eventName: string) {
    gtag('event', eventName, {
      'event_category': 'rmc_endcoverage',
      'event_label': eventName
    });
  }

}